import axios from "axios";
import { useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";

const AdminControl = () => {
  const [result, setResult] = useState([]);
  const [info, setInfo] = useState({});
  const [updateInfo, setUpdateInfo] = useState({ validation: "" });
  const [checkedList, setCheckedList] = useState([]);

  // '처리'버튼 이벤트 처리
  const updateStatus = async () => {
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    console.log(updateInfo);
    if (updateInfo.validation == null || updateInfo.validation == "") {
      alert("검사 항목을 선택하세요.");
      return;
    }
    if (checkedList.length == 0) {
      alert("체크박스를 적어도 한개 이상 체크해야됩니다.");
      return;
    }
    try {
      let tmpJSON = [...checkedList];
      tmpJSON.map((item, key) => {
        item.validation = updateInfo.validation;
        item.backNo = item.joinSeq; // runnerSeq -> backNo로 처리됨
      });
      console.log(tmpJSON);
      let response = await axios.post(
        `${root_url}/api/admin/transform`,
        tmpJSON,
        headers
      );
      alert("성공");
      handleSubmit();
    } catch (error) {
      console.log(error);
      if (error.response.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
    }
  };

  // '검색'버튼 이벤트 처리
  const handleSubmit = async (e) => {
    e?.preventDefault();
    console.log(info);
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };

    try {
      let response = await axios.post(
        `${root_url}/api/admin/checkLocation`,
        info,
        headers
      );
      setResult([]);
      setCheckedList([]); // 체크리스트를 검색하고 나면 초기화 해야 하는데,,,,,
      console.log("[info정보로 검색] : ", response.data);
      setResult(response.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
    }
  };

  return (
    <Container>
      <h1 id="outline" className="mt-5 mb-5 pt-3 text-center">
        기록 관리 (10km, 18km)
      </h1>
      <Form inline onSubmit={handleSubmit}>
        <Row>
          <Col>
            <Form.Control
              as="select"
              onChange={(e) => {
                let ticketSeq = e.target.value;
                setInfo({ ...info, ticketSeq: ticketSeq });
              }}
            >
              <option value="">종목</option>
              <option value={1}>10Km</option>
              <option value={6}>18Km</option>
            </Form.Control>
          </Col>
          <Col>
            <Form.Group style={{ display: "flex" }}>
              <Form.Control
                type="date"
                id=""
                onChange={(e) => {
                  let searchDate = e.target.value;
                  setInfo({ ...info, searchDate: searchDate });
                }}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Control
              type="input"
              id=""
              placeholder="신청자명"
              htmlFor="inlineFormCustomSelectPref"
              onChange={(e) => {
                let joinerName = e.target.value;
                setInfo({ ...info, joinerName: joinerName });
              }}
            ></Form.Control>
          </Col>
          <Col>
            <Form.Control
              as="select"
              className="my-1 mr-sm-2"
              id="inlineFormCustomSelectPref"
              custom
              onChange={(e) => {
                let gender = e.target.value;
                setInfo({ ...info, gender: gender });
              }}
            >
              <option value="">성별</option>
              <option value="M">남자</option>
              <option value="F">여자</option>
            </Form.Control>
          </Col>
          <Col>
            <Form.Control
              as="select"
              className="my-1 mr-sm-2"
              id="inlineFormCustomSelectPref"
              custom
              onChange={(e) => {
                let validation = e.target.value;
                setInfo({ ...info, validation: validation });
              }}
            >
              <option value="">검사</option>
              <option value="true">OK</option>
              <option value="false">NG</option>
            </Form.Control>
          </Col>
          <Col>
            <Button className="me-4" type="submit">
              검색
            </Button>
          </Col>
        </Row>
      </Form>
      <Form>
        <Row>
          <Col>
            <Form.Control
              as="select"
              className="mb-3 mt-3"
              onChange={(e) => {
                let validation = e.target.value;
                setUpdateInfo({ validation: validation });
              }}
            >
              <option value="">검사</option>
              <option value="true">OK</option>
              <option value="false">NG</option>
            </Form.Control>
          </Col>
          <Col>
            <Button
              className="me-4 mb-3 mt-3"
              onClick={() => {
                updateStatus();
              }}
            >
              처리
            </Button>
          </Col>
        </Row>
      </Form>
      <Table bordered className="text-center" style={{ minWidth: "700px" }}>
        <thead>
          <tr style={{ color: "white" }} className="bg-custom-color">
            <th width="4%">선택</th>
            <th>종목</th>
            <th>접수번호</th>
            <th>이름</th>
            <th width="4%">성별</th>
            <th>전화번호</th>
            <th>참가일자</th>
            <th>출발시간</th>
            <th>종료시간</th>
            <th>소요시간</th>
            <th>검사</th>
            <th>기록확인</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, key) => {
            return (
              <tr key={key}>
                <td>
                  <Form.Check
                    aria-label="option 1"
                    onChange={(e) => {
                      if (checkedList.length == 0) {
                        console.log("checkedList 비어있음 : ", item);
                        setCheckedList([item]);
                      } else {
                        let flag = false;
                        console.log(typeof checkedList);
                        checkedList.forEach((e) => {
                          if (e == item) {
                            flag = true;
                            console.log("이미 값이 있음");
                          }
                        });
                        if (flag) {
                          let tmpArray = checkedList.filter(
                            (element) => element !== item
                          );
                          console.log(
                            "중복된 값을 제외합니다. ",
                            tmpArray,
                            typeof checkedList
                          );
                          setCheckedList(tmpArray);
                        } else {
                          console.log("중복된 값이 없습니다. ", [
                            ...checkedList,
                            item,
                          ]);
                          setCheckedList([...checkedList, item]);
                        }
                      }
                    }}
                  />
                </td>
                <td>{item.ticketName}</td>
                <td>{item.joinSeq}</td>
                <td>{item.runnerName}</td>
                <td>{item.gender}</td>
                <td>{item.cellphone}</td>
                <td>{(item.startTime + "").split("T")[0]}</td>
                <td>{(item.startTime + "").split("T")[1]}</td>
                <td>{(item.finishTime + "").split("T")[1]}</td>
                <td>{item.elapseTime}</td>
                <td>
                  {item.validation ? "OK" : !item.validation ? "NG" : "-"}
                </td>
                <td>
                  <Link
                    to={`/admin/events/map?runnerSeq=${item.runnerSeq}&runnerName=${item.runnerName}&cellphone=${item.cellphone}&ticketName=${item.ticketName}`}
                    target="_blank"
                  >
                    맵보기
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};

export default AdminControl;
